import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthShell, GoogleButton, inputClass } from "@/pages/authShared";

export default function Login() {
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { loginWithToken } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { identifier, password });
      loginWithToken(data.token, data.user);
      toast.success(`Welcome back, ${data.user.name.split(" ")[0]}!`);
      navigate(location.state?.from || "/market", { replace: true });
    } catch (err) {
      const msg = formatError(err.response?.data?.detail) || "Login failed";
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Welcome back" subtitle="Sign in to shop this Market Day">
      <form onSubmit={submit} className="space-y-3">
        <input
          className={inputClass}
          placeholder="Email or phone number"
          value={identifier}
          onChange={(e) => setIdentifier(e.target.value)}
          data-testid="login-identifier"
          required
        />
        <input
          className={inputClass}
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          data-testid="login-password"
          required
        />
        <div className="text-right">
          <Link to="/forgot-password" className="text-sm font-semibold text-[#0B7A3B]" data-testid="forgot-link">
            Forgot password?
          </Link>
        </div>
        {error && (
          <div className="text-sm font-semibold text-[#C0392B] bg-[#C0392B]/10 rounded-[12px] px-3 py-2.5" data-testid="login-error">{error}</div>
        )}
        <button
          type="submit"
          disabled={loading}
          data-testid="login-submit"
          className="w-full bg-[#0B7A3B] text-white font-bold rounded-full py-3 active:scale-95 transition-transform hover:bg-[#095F2E] disabled:opacity-60"
        >
          {loading ? "Signing in…" : "Sign In"}
        </button>
      </form>

      <div className="flex items-center gap-3 my-4">
        <div className="flex-1 h-px bg-[#F5F8F6]" />
        <span className="text-xs text-[#6B8375]">or</span>
        <div className="flex-1 h-px bg-[#F5F8F6]" />
      </div>
      <GoogleButton />

      <p className="text-center text-sm text-[#6B8375] mt-5">
        New here?{" "}
        <Link to="/register" className="font-bold text-[#0B7A3B]" data-testid="go-register">
          Create an account
        </Link>
      </p>
    </AuthShell>
  );
}
